import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 bg-white transition-all duration-300 ${
        scrolled ? "shadow-md" : ""
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between h-16">
        <img
          src="https://storage.readdy-site.link/project_files/ca8f3ce7-75b3-4a89-a83a-a57d16fa0d98/05b78201-11a3-4523-906e-181829bd6337_8281.1_Selo_UnimedBH_55_anos.png?v=3bb13cfb1dcab1b33b447ea11f63d8d1"
          alt="Logo"
          className="h-10 w-auto object-contain"
        />
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: "Programação", id: "cronograma" },
            { label: "Modalidades", id: "modalidades-mente" },
            { label: "Informações", id: "informacoes" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-semibold text-[#008C51] hover:text-[#BCD033] transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <span
            className="bg-gray-400 text-white text-sm font-bold px-5 py-2 rounded-full cursor-not-allowed whitespace-nowrap"
          >
            Inscrições encerradas
          </span>
        </div>

        <button
          className="md:hidden cursor-pointer p-2"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl text-[#008C51]`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {[
            { label: "Programação", id: "cronograma" },
            { label: "Modalidades", id: "modalidades-mente" },
            { label: "Informações", id: "informacoes" },
            { label: "Inscrições", id: "inscricoes" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-left text-sm font-semibold text-[#008C51] hover:text-[#BCD033] cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}